<template>
  <span
    class="tool-tip"
    v-if="showToolTip"
  >
    <v-tooltip
      :left="left"
      :right="right"
      :top="top"
      :bottom="bottom"
    >
      <template #activator="{on, attrs}">
        <span v-on="on" v-bind="attrs"><slot /></span>
      </template>
      <span>
        {{ message }}
      </span>
    </v-tooltip>
  </span>

  <!-- Support the ability to programmatically turn tool tips on or off based on showToolTip prop -->
  <span v-else>
    <slot/>
  </span>

</template>

<script>
  export default {
    props: {
      showToolTip: {
        type: Boolean,
        default: true
      },
      message: {
        type: String
      },
      left: {
        type: Boolean,
        default: false
      },
      right: {
        type: Boolean,
        default: false
      },
      top: {
        type: Boolean,
        default: false
      },
      bottom: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped>
  .tool-tip:hover {
    cursor:pointer;
  }
</style>
